<template>
  <p class="p-form-uneditable-text"><slot></slot></p>
</template>

<style lang="scss" scoped>
.p-form-uneditable-text {
  font-size: rem(14);
  line-height: (19/14);
  padding: rem(10) 0 rem(11) 0;
}
</style>
